module.exports = __webpack_public_path__ + "img/magnifying-glass.e7a12c7c.png";